var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3328 5.33285L13.9995 7.99951M13.9995 7.99951L11.3328 10.6662M13.9995 7.99951H5.99948M7.99948 1.99951H4.13333C3.3866 1.99951 3.01323 1.99951 2.72801 2.14484C2.47713 2.27267 2.27316 2.47664 2.14532 2.72752C2 3.01274 2 3.38611 2 4.13284V11.8662C2 12.6129 2 12.9863 2.14532 13.2715C2.27316 13.5224 2.47713 13.7264 2.72801 13.8542C3.01323 13.9995 3.3866 13.9995 4.13333 13.9995H7.99948",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e451b81eb6c484d0b8b26107f1a293b4.svg";
export { ForwardRef as ReactComponent };